'use client'

import { useSyncExternalStore } from 'react'

const listeners = new Set<() => void>()
let activeUploadCount = 0

function emit(): void {
  for (const listener of listeners) listener()
}

export function isUploadInProgress(): boolean {
  return activeUploadCount > 0
}

export function subscribeUploadActivity(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

/** Starts a process-wide upload boundary and returns an idempotent release. */
export function beginUploadActivity(): () => void {
  activeUploadCount += 1
  emit()
  let active = true
  return () => {
    if (!active) return
    active = false
    activeUploadCount = Math.max(0, activeUploadCount - 1)
    emit()
  }
}

export function useUploadInProgress(): boolean {
  return useSyncExternalStore(subscribeUploadActivity, isUploadInProgress, () => false)
}
